﻿import {Core} from "../../Base/Core";
import {BoosterType, GameCategory, GameScreen, MoneyType, RewardType, UIState} from "../../enums";
import {NUtils} from "../../Utils/NUtils";
import {Utils} from "../../Utils/Utils";
import {UIButton} from "../Tools/Base/UIButton";
import {UIText} from "../Tools/Base/UIText";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {Scrollbox} from "pixi-scrollbox";
import {UISprite} from "../Tools/Base/UISprite";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UILabeledIcon} from "../Tools/Base/UILabeledIcon";
import {UINineSlice} from "../Tools/Base/UINineSlice";
import {Price, Reward} from "../../Data/GameData";
import {RewardedAdsBtn} from "../RewardedAdsBtn";

const BankProductsConfig = {
    Boosters: [
        {
            type: BoosterType.Income,
            title: "booster_income_title",
            description: "booster_income_desc",
            image: "x2",
        },
        {
            type: BoosterType.BubbleTime,
            title: "booster_bubble_time_title",
            description: "booster_bubble_time_desc",
            image: "upgrades/booster-fasterbubble-ico",
        },
        {
            type: BoosterType.CreaturesDiscount,
            title: "booster_monster_discount",
            description: "booster_monster_discount_desc",
            image: "upgrades/booster-monstersale-ico",
        },
    ],
    HardMoney: [
        {
            id: "hard1",
            price: "$$$",
            reward: new Reward({ type: RewardType.MoneyHard, valueStr: "60" }),
            title: "hard_pack_1_title",
            image: "bank/pack-gems-box",
        },
        {
            id: "hard2",
            price: "$$$",
            reward: new Reward({ type: RewardType.MoneyHard, valueStr: "500" }),
            title: "hard_pack_2_title",
            image: "bank/pack-gems-sack",
        },
        {
            id: "hard3",
            price: "$$$",
            reward: new Reward({ type: RewardType.MoneyHard, valueStr: "3500" }),
            title: "hard_pack_3_title",
            image: "bank/pack-gems-case",
        },
        {
            id: "ads",
            price: null,
            reward: new Reward({ type: RewardType.MoneyHard, valueStr: "3" }),
            title: "",
            image: "bank/pack-gems-handful",
        },
    ],
    NoAds: {
        id: "noads",
        price: "$$$",
        reward: new Reward({ type: RewardType.NoAds, valueStr: "1" }),
        title: "no_ads_title",
        description: "no_ads_description",
        image: "offers/noads",
    },
    SoftMoney: [
        {
            id: "soft1",
            price: new Price({ priceType: MoneyType.Hard, priceValueStr: "59" }),
            reward: new Reward({ type: RewardType.MoneySoft, valueStr: "43100000000000000000" }),
            title: "soft_pack_1_title",
            image: "bank/pack-gold-sack",
        },
        {
            id: "soft2",
            price: new Price({ priceType: MoneyType.Hard, priceValueStr: "199" }),
            reward: new Reward({ type: RewardType.MoneySoft, valueStr: "172400000000000000000" }),
            title: "soft_pack_2_title",
            image: "bank/pack-gold-safe",
        },
        {
            id: "soft3",
            price: new Price({ priceType: MoneyType.Hard, priceValueStr: "349" }),
            reward: new Reward({ type: RewardType.MoneySoft, valueStr: "344800000000000000000" }),
            title: "soft_pack_3_title",
            image: "bank/pack-gold-mountain",
        },
    ],
};

function moneyIcon(type) {
    switch (type) {
        case MoneyType.Soft:
            return "ico-gold";
        case MoneyType.Hard:
            return "ico-diamond";
        default:
            return "";
    }
}

class BoostersItem extends UISprite {
    constructor(config) {
        super();

        this.onClick = this.onClick.bind(this);

        this.config = config;

        this.back = this.addChild(new UINineSlice("bg-rounding-28px"));
        this.back.tint = 0x000000;
        this.back.alpha = 0.3;

        this.picture = this.addChild(new UISprite(config.image));

        this.title = this.addChild(new UIText(Core.Localizator.Get(config.title)));

        this.durationBack = this.addChild(new UINineSlice("bg-simple"));
        this.durationBack.tint = 0x000000;
        this.durationBack.alpha = 0.3;
        this.clock = this.addChild(new UISprite("ico-clock"));
        this.duration = this.addChild(new UIText(""));

        this.descriptionBack = this.addChild(new UINineSlice("bg-simple"));
        this.descriptionBack.tint = 0x000000;
        this.descriptionBack.alpha = 0.3;
        this.description = this.addChild(new UIText(Core.Localizator.Get(config.description)));

        this.btn = this.addChild(
            new UINineSliceButton("btn-blue", {
                label: "",
                icon: "ico-diamond",
                iconAlign: "right",
                iconSize: 0.9,
            })
        );
        this.btn.on("pointertap", this.onClick);
    }

    Init() {
        let storeConfig = Core.GameData.AppStore.GetBooster(this.config.type);
        this.config.price = new Price(storeConfig.price);
        this.duration.text = Utils.Format(
            "{0}h",
            Math.floor(storeConfig.durationSeconds / 60 / 60)
        );

        this.btn.label = NUtils.FormatMoney(Core.GameData.AppStore.GetBooster(this.config.type).price.priceValue);
        this.btn.icon = moneyIcon(this.config.price.priceType);
    }

    onClick() {
        let boosterData = Core.GameData.AppStore.GetBooster(this.config.type);
        if (Core.Player.SpendMoney(boosterData.price, GameCategory.booster, GameScreen.boosters, boosterData.boosterType)) {
            Core.Analytics.SendBoosterEvent(this.config.type);
            Core.Boosters.AddBoosterTime(this.config.type, boosterData.durationSeconds);
        } else {
            Core.UI.notEnoughHardMoney.Show();
        }
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);

        let rect = parentRect.clone();
        rect.x = rect.y = 0;

        this.back.width = rect.width;
        this.back.height = rect.height;

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.2;
        rect.height = parentRect.height * 0.6;
        rect.x = (parentRect.width - rect.width) * 0.05;
        rect.y = (parentRect.height - rect.height) * 0.08;
        this.picture.fitRect(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.47;
        rect.height = parentRect.height * 0.25;
        rect.x = (parentRect.width - rect.width) * 0.47;
        rect.y = (parentRect.height - rect.height) * 0.08;
        this.title.anchor.set(0, 0.5);
        this.title.fitLayout(rect);

        let durationRect = new PIXI.Rectangle();
        durationRect.width = parentRect.width * 0.37;
        durationRect.height = parentRect.height * 0.17;
        durationRect.x = (parentRect.width - durationRect.width) * 0.45;
        durationRect.y = (parentRect.height - durationRect.height) * 0.45;
        this.durationBack.fitLayout(durationRect);

        rect = durationRect.clone();
        rect.width = rect.height = durationRect.height * 1.5;
        rect.x = durationRect.x + (durationRect.width - rect.width) * 0 - rect.width * 0.5;
        rect.y = durationRect.y + (durationRect.height - rect.height) * 0.5;
        this.clock.fitRect(rect);

        rect = durationRect.clone();
        rect.width = rect.height = durationRect.height;
        rect.x = durationRect.x + (durationRect.width - rect.width) * 0.5;
        rect.y = durationRect.y + (durationRect.height - rect.height) * 0.5;
        this.duration.fitLayout(rect);

        let descriptionRect = new PIXI.Rectangle();
        descriptionRect.width = parentRect.width * 0.9;
        descriptionRect.height = parentRect.height * 0.3;
        descriptionRect.x = (parentRect.width - descriptionRect.width) * 0.5;
        descriptionRect.y = (parentRect.height - descriptionRect.height) * 0.9;
        this.descriptionBack.fitLayout(descriptionRect);

        rect = descriptionRect.clone();
        rect.width = descriptionRect.width * 0.9;
        rect.height = descriptionRect.height;
        rect.x = descriptionRect.x + (descriptionRect.width - rect.width) * 0.5;
        rect.y = descriptionRect.y + (descriptionRect.height - rect.height) * 0.5;
        this.description.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.25;
        rect.height = parentRect.height * 0.4;
        rect.x = (parentRect.width - rect.width) * 0.95;
        rect.y = (parentRect.height - rect.height) * 0.3;
        this.btn.fitLayout(rect);
    }
}

class HardMoneyItem extends UISprite {
    constructor(config) {
        super();

        this.onClick = this.onClick.bind(this);

        this.config = config;

        this.back = this.addChild(new UISprite("offers/shop-bg"));
        this.picture = this.addChild(new UISprite(config.image));
        this.title = this.addChild(new UIText(Core.Localizator.Get(config.title)));
        this.title.SetActive(!!config.title);
        this.reward = this.addChild(
            new UILabeledIcon({
                label: "",
                icon: "ico-diamond",
                iconAlign: "right",
                iconSize: 1,
            })
        );
        this.btn = this.addChild(config.id === "ads"
            ? new RewardedAdsBtn("btn-green", {label: Core.Localizator.Get(config.id)})
            : new UINineSliceButton("btn-green", {label: config.price})
        );
        this.mask = this.addChild(new PIXI.Graphics());

        this.btn.on("pointertap", this.onClick);
    }

    Init() {
        if (this.config.id !== "ads") {
            let product = Core.Store.GetProduct(this.config.id);
            if (product) {
                this.btn.label = product.GetPrice();
                this.config.reward = product.rewards[0];
            }
            else {
                // Product not configured in store
                this.SetActive(false);
            }
        }
        else {
            this.config.reward = Core.GameData.AppStore.hardAdsBonusReward;
        }
        this.reward.label = NUtils.FormatMoney(this.config.reward.realValue);
    }

    onClick() {
        if (this.config.id === "ads") {
            Core.Ads.TriggerRewarded(() => Core.GameData.AppStore.hardAdsBonusReward.Take(this.config.id));
        } else {
            Core.Store.BuyProductID(this.config.id);
        }
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);

        let rect = parentRect.clone();
        rect.x = rect.y = 0;

        this.back.anchor.set(0, 0);
        this.back.scale.set(rect.width / this.back.texture.width, rect.height / this.back.texture.height);

        this.mask.clear().beginFill(0xffffff, 1).drawRoundedRect(rect.x, rect.y, rect.width, rect.height, 28);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.7;
        rect.height = parentRect.height * 0.2;
        rect.x = (parentRect.width - rect.width) * 0.5;
        rect.y = (parentRect.height - rect.height) * 0.05;
        this.title.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.4;
        rect.height = parentRect.height * 0.22;
        rect.x = (parentRect.width - rect.width) * 0.5;
        rect.y = (parentRect.height - rect.height) * (this.config.title === "" ? 0.05 : 0.35);
        this.reward.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.4;
        rect.height = parentRect.height * 0.7;
        rect.x = (parentRect.width - rect.width) * 0.05;
        rect.y = (parentRect.height - rect.height) * 0.9;
        this.picture.fitRect(rect, true);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.35;
        rect.height = parentRect.height * 0.35;
        rect.x = (parentRect.width - rect.width) * 0.9;
        rect.y = (parentRect.height - rect.height) * 0.9;
        this.btn.fitLayout(rect);
    }
}

class NoAdsItem extends UISprite {
    constructor(config) {
        super();

        this.onClick = this.onClick.bind(this);

        this.config = config;

        this.back = this.addChild(new UISprite(PIXI.Texture.WHITE));
        this.back.tint = 0x000000;
        this.back.alpha = 0.3;

        this.picture = this.addChild(new UISprite(config.image));
        this.title = this.addChild(new UIText(Core.Localizator.Get(config.title)));
        this.title.anchor.set(0, 0.5);
        this.description = this.addChild(new UIText(Core.Localizator.Get(config.description), {wordWrap: false}));
        this.btn = this.addChild(new UINineSliceButton("btn-green", {label: config.price}));
        this.mask = this.addChild(new PIXI.Graphics());
        this.btn.on("pointertap", this.onClick);
    }

    Init() {
        return this.Update();
    }

    Update() {
        let product = Core.Store.GetProduct(this.config.id);
        this.SetActive(product && !Core.Player.NoAds);
        this.btn.label = this.Active ? product.GetPrice() : "";
    }

    onClick() {
        Core.Store.BuyProductID(this.config.id);
    }

    fitLayout(parentRect) {

        this.position.copyFrom(parentRect);
        this.y += parentRect.height;

        let rect = parentRect.clone();
        rect.x = rect.y = 0;

        this.back.anchor.set(0, 0);
        this.back.scale.set(rect.width / this.back.texture.width, rect.height / this.back.texture.height);

        this.mask.clear().beginFill(0xffffff, 1).drawRoundedRect(rect.x, rect.y, rect.width, rect.height, 28);

        let pictureRect = rect.clone();
        pictureRect.width *= 0.3;
        pictureRect.pad(-pictureRect.width * 0.05, 0);
        this.picture.fitRect(pictureRect);

        let titleRect = rect.clone();
        titleRect.height *= 0.4;
        titleRect.y = rect.height * 0.1;
        titleRect.width = rect.width * 0.9 - pictureRect.width;
        titleRect.x = pictureRect.right + rect.width * 0.05;
        this.title.fitLayout(titleRect);

        let descRect = titleRect.clone();
        descRect.y = titleRect.bottom;
        descRect.height = rect.height - titleRect.bottom - rect.height * 0.1;
        descRect.width *= 0.5;
        this.description.fitLayout(descRect);

        let btnRect = descRect.clone();
        btnRect.x = descRect.right;
        btnRect.width = titleRect.width - descRect.width;
        btnRect.pad(-btnRect.width * 0.1, 0);
        this.btn.fitLayout(btnRect);
    }
}

class SoftMoneyItem extends UISprite {
    constructor(config) {
        super();

        this.onClick = this.onClick.bind(this);

        this.config = config;

        this.back = this.addChild(new UINineSlice("bg-rounding-28px"));
        this.back.tint = 0x000000;
        this.back.alpha = 0.3;

        this.picture = this.addChild(new UISprite(config.image));
        this.title = this.addChild(new UIText(Core.Localizator.Get(config.title)));
        this.reward = this.addChild(
            new UILabeledIcon({
                label: NUtils.FormatMoney(config.reward.value),
                icon: "ico-gold",
                iconAlign: "right",
                iconSize: 1,
            })
        );
        this.btn = this.addChild(
            new UINineSliceButton("btn-green", {
                label: "",
                icon: "ico-diamond",
                iconAlign: "right",
                iconSize: 1,
            })
        );

        this.btn.on("pointertap", this.onClick);
    }

    Init() {
        let storeConfig = Core.GameData.AppStore.GetInGameProduct(this.config.id);
        this.config.price = new Price(storeConfig.price);
        this.config.reward = new Reward(storeConfig.rewards[0]);

        this.btn.label = NUtils.FormatMoney(this.config.price.priceValue);
        this.btn.icon = moneyIcon(this.config.price.priceType);

        this.reward.label = NUtils.FormatMoney(this.config.reward.realValue);
    }

    onClick() {
        if (Core.Player.SpendMoney(this.config.price)) {
            this.config.reward.Take(this.config.id);
        } else {
            Core.UI.notEnoughHardMoney.Show();
        }
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);

        let rect = parentRect.clone();
        rect.x = rect.y = 0;

        this.back.width = rect.width;
        this.back.height = rect.height;

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.7;
        rect.height = parentRect.height * 0.22;
        rect.x = (parentRect.width - rect.width) * 0.5;
        rect.y = (parentRect.height - rect.height) * 0.05;
        this.title.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.4;
        rect.height = parentRect.height * 0.24;
        rect.x = (parentRect.width - rect.width) * 0.5;
        rect.y = (parentRect.height - rect.height) * (this.config.title === "" ? 0.05 : 0.35);
        this.reward.fitLayout(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.4;
        rect.height = parentRect.height * 0.7;
        rect.x = (parentRect.width - rect.width) * 0.05;
        rect.y = (parentRect.height - rect.height) * 0.75;
        this.picture.fitRect(rect, true);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.35;
        rect.height = parentRect.height * 0.35;
        rect.x = (parentRect.width - rect.width) * 0.9;
        rect.y = (parentRect.height - rect.height) * 0.9;
        this.btn.fitLayout(rect);

        let btnRect = new PIXI.Rectangle(0, 0, this.btn.width, this.btn.height).pad(-this.btn.width * 0.05, -this.btn.height * 0.2);
        this.btn.content.fitLayout(btnRect);
    }
}

class BankSection extends UISprite {
    Awake() {
        super.Awake();
        this.title = this.addChild(new UIText(""));
        this.content = this.addChild(new UISprite());
    }

    fitLayout(rect) {
        this.position.set(0, rect.bottom);

        let titleRect = rect.clone();
        titleRect.height = rect.width * 0.13;
        titleRect.x = 0;
        titleRect.y = rect.width * 0.08;
        this.title.fitLayout(titleRect);

        this.content.position.set(0, titleRect.bottom);
        rect.height += titleRect.height + titleRect.y;
    }
}

class SectionVIP extends BankSection {
    Awake() {
        super.Awake();
        this.title.text = Core.Localizator.Get("vip");
        let icon = new UISprite("offers/vip-badge-bg");
        icon.addChild(new UISprite("offers/crown"));
        this.btn = this.content.addChild(
            new UINineSliceButton("btn-green", {
                label: Core.Localizator.Get("gold_membership"),
                icon,
                iconSize: 1,
            })
        );
        this.btn.on("pointertap", () => Core.UI.vip.Show());
    }

    Update() {
        this.SetActive(false); // XXX: VIP temporary off
        // this.SetActive(!Core.Store.VipActive);
    }

    fitLayout(rect) {
        super.fitLayout(rect);

        let buttonRect = rect.clone();
        buttonRect.height = rect.width * 0.3;
        buttonRect.x = 0;
        buttonRect.y = rect.width * 0.01;
        this.btn.fitLayout(buttonRect);
        this.btn.content._icon.y -= buttonRect.height * 0.03;

        rect.height += buttonRect.height + buttonRect.y;
    }
}

class SectionBoosters extends BankSection {
    Awake() {
        super.Awake();
        this.title.text = Core.Localizator.Get("boosters");

        this.items = [];

        for (let config of BankProductsConfig.Boosters) {
            this.items.push(this.content.addChild(new BoostersItem(config)));
        }
    }

    Init() {
        for (let item of this.items) {
            item.Init();
        }
    }

    fitLayout(rect) {
        super.fitLayout(rect);

        let itemRect = rect.clone();
        itemRect.height = rect.width * 0.35;
        itemRect.y = itemRect.width * 0.05;

        let padding = itemRect.width * 0.07;
        let offset = itemRect.height + padding;
        for (let item of this.items) {
            item.fitLayout(itemRect);
            itemRect.y += offset;
        }

        rect.height += itemRect.y - padding;
    }
}

class SectionHardMoney extends BankSection {
    Awake() {
        super.Awake();
        this.title.text = Core.Localizator.Get("hard_money");

        this.items = [];

        for (let config of BankProductsConfig.HardMoney) {
            this.items.push(this.content.addChild(new HardMoneyItem(config)));
        }
        this.noAds = this.addChild(new NoAdsItem(BankProductsConfig.NoAds));
    }

    Init() {
        for (let item of this.items) {
            item.Init();
        }
    }

    Update() {
        for (let item of this.items) item.Update();
        this.noAds.Update();
    }

    fitLayout(rect) {
        super.fitLayout(rect);

        let itemRect = rect.clone();
        itemRect.height = rect.width * 0.5;
        itemRect.y = itemRect.width * 0.05;

        let padding = itemRect.width * 0.07;
        let offset = itemRect.height + padding;
        let items = this.items.filter(item => item.Active);
        for (let item of items) {
            item.fitLayout(itemRect);
            itemRect.y += offset;
        }

        if (this.noAds.Active) {
            let adsRect = itemRect.clone();
            adsRect.height *= 0.5;
            this.noAds.fitLayout(adsRect);
            itemRect.y += adsRect.height + padding;
        }

        rect.height += itemRect.y - padding;
    }
}

class SectionSoftMoney extends BankSection {
    Awake() {
        super.Awake();
        this.title.text = Core.Localizator.Get("soft_money");

        this.items = [];

        for (let config of BankProductsConfig.SoftMoney) {
            this.items.push(this.content.addChild(new SoftMoneyItem(config)));
        }
    }

    Init() {
        for (let item of this.items) {
            item.Init();
        }
    }

    fitLayout(rect) {
        super.fitLayout(rect);

        let itemRect = rect.clone();
        itemRect.height = rect.width * 0.45;
        itemRect.y = itemRect.width * 0.05;

        let padding = itemRect.width * 0.07;
        let offset = itemRect.height + padding;
        for (let item of this.items) {
            item.fitLayout(itemRect);
            itemRect.y += offset;
        }

        rect.height += itemRect.y;
        rect.height += offset * 0.3; // Bottom margin
    }
}

export class UIBank extends UICommonPopup {
    Awake() {
        super.Awake({
            masked: true,
        });

        this.scrollbox = this.content.addChild(new Scrollbox({
            overflow: "hidden",
            interaction: Core.app.renderer.plugins.interaction,
        }));

        this.btnClose = this.content.addChild(new UIButton("button-close")); // Button btnClose;
        this.btnClose.alpha = 0.5;

        this.vip = this.scrollbox.content.addChild(new SectionVIP());
        this.boosters = this.scrollbox.content.addChild(new SectionBoosters());
        this.hardMoney = this.scrollbox.content.addChild(new SectionHardMoney());
        this.softMoney = this.scrollbox.content.addChild(new SectionSoftMoney());

        this.sections = [this.vip, this.boosters, this.hardMoney, this.softMoney];

        this.HideWithBackButton = true;
    }

    Init() {
        super.Init();

        this.onClickClose = this.onClickClose.bind(this);
        this.onProductPurchased = this.onProductPurchased.bind(this);

        this.btnClose.on("pointertap", this.onClickClose);
        this.antiClick.on("pointertap", this.onClickClose);

        Core.Store.on("Purchased", this.onProductPurchased);
    }

    fitSections(width = this.scrollbox.scrollWidth) {
        let scrollContentRect = new PIXI.Rectangle(0, 0, width, 0);

        // Each section should increase height by reference
        for (let section of this.sections) {
            if (section.Active) {
                section.fitLayout(scrollContentRect);
            }
        }
        return scrollContentRect;
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.7;
        let w = Math.min(viewport.width * 0.85, (viewport.height * 0.85) / sideRatio);
        let h = w * sideRatio;

        this.setPopupSize(w, h);

        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        this.btnClose.scale = this.closeBtn.scale;
        this.btnClose.position = this.closeBtn.position;

        let scrollRect = contentRect.clone().pad(-contentRect.width * 0.05, 0);
        let scrollContentRect = this.fitSections(scrollRect.width);
        this.scrollbox.position.copyFrom(scrollRect);
        this.scrollbox.resize({
            boxWidth: scrollRect.width,
            boxHeight: scrollRect.height,
            scrollWidth: scrollContentRect.width,
            scrollHeight: scrollContentRect.height,
        });

        this._renderMask();
    }

    // private void onProductPurchased(AppStoreProduct product)
    onProductPurchased(product) {
        if (product.id == "vip") {
            this.vip.SetActive(false);
        }
        this.Update();
        this.fitLayout();
    }

    Update() {
        for (let section of this.sections) {
            section.Update();
        }
    }

    Show() {
        for (let section of this.sections) {
            section.Init();
        }

        this.Update();
        this.fitLayout();

        switch (Core.UI.state) {
            case UIState.BankHard:
                this.scrollbox.scrollTop = this.hardMoney.y;
                break;

            case UIState.BankSoft:
                this.scrollbox.scrollTop = this.softMoney.y;
                break;

            default:
                this.scrollbox.scrollTop = 0;
                break;
        }

        super.Show();
    }

    onClickClose() {
        Core.UI.SetState(UIState.Game);
    }

    Hide() {
        if (this.Active) {
            Core.Ads.TriggerInterstitial();
        }
        super.Hide();
    }
}
